import React, { useEffect, useState } from 'react';
import authMobileImg from '@/assets/images/mobile/auth_mobile.png';
import dbMobileImg from '@/assets/images/mobile/db_mobile.png';

/**
 * More/Plus Icon - Neon line-art style
 */
const MoreIcon = () => (
  <svg width="32" height="32" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="18" stroke="currentColor" strokeWidth="2.5" strokeDasharray="6 4" />
    <line x1="24" y1="16" x2="24" y2="32" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <line x1="16" y1="24" x2="32" y2="24" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

/**
 * Image-based Icon Card Component
 */
const ImgIconCard = ({ src, alt, label }) => (
  <div
    className="flex flex-col items-center justify-center bg-border dark:bg-white rounded-2xl"
    style={{ width: '92px', height: '92px' }}
  >
    <img
      src={src}
      alt={alt}
      style={{ width: '44px', height: '44px', objectFit: 'contain' }}
    />
    <span className="text-[9px] font-semibold uppercase tracking-wider text-black mt-1">{label}</span>
  </div>
);

/**
 * Icon Card Component - SVG based
 */
const IconCard = ({ icon: Icon, label }) => (
  <div
    className="flex flex-col items-center justify-center bg-border dark:bg-white rounded-2xl"
    style={{ width: '92px', height: '92px' }}
  >
    <div className="mb-1 text-[#1a472a] scale-[1.1]"><Icon /></div>
    <span className="text-[9px] font-semibold uppercase tracking-wider text-black">{label}</span>
  </div>
);

/**
 * Payment Card - Shows only Razorpay logo
 */
const PaymentLogosCard = () => {
  return (
    <div
      id="payments-card"
      className="flex flex-col items-center justify-center bg-border dark:bg-white rounded-2xl"
      style={{ width: '92px', height: '92px' }}
    >
      {/* Razorpay logo only */}
      <img
        id="razorpay-static"
        src="/payment-logos/razorpay.png"
        alt="Razorpay"
        style={{
          width: '44px',
          height: '44px',
          objectFit: 'contain',
        }}
      />
      <span className="text-[9px] font-semibold uppercase tracking-wider text-black mt-1">
        PAYMENTS
      </span>
    </div>
  );
};

/**
 * Mobile Icon Row
 */
const MobileIconRow = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div
      className="mobile-icon-row px-4 py-6 flex items-center justify-center bg-[var(--pluckr-bg-soft)]"
      style={{ minHeight: '120px' }}
      data-testid="mobile-icon-row"
    >
      <div
        className={
          `flex gap-3 justify-center transform transition-all duration-700 ease-out ` +
          (isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6')
        }
      >
        <PaymentLogosCard />
        <ImgIconCard src={authMobileImg} alt="Auth" label="AUTH" />
        <ImgIconCard src={dbMobileImg} alt="Database" label="DATABASE" />
        <IconCard icon={MoreIcon} label="MORE SOON" />
      </div>
    </div>
  );
};

export default MobileIconRow;
